<template>
  <div>
    <div style="margin-bottom: 16px">
      <el-button class="mwow-button-filled success" @click="handleAddPackage"
        >添加课包</el-button
      >
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleResetSearch">
      <el-form size="mini" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="课包名称:" prop="name">
              <el-input
                placeholder="请输入课包名称"
                v-model="searchInfo.name"
                maxlength="100"
                @change="handleSearchPackage"
                prefix-icon="el-icon-search"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课时数量:">
              <div style="display: flex">
                <el-input
                  v-model="searchInfo.quantity_1"
                  @change="
                    (v) => {
                      if (v > 2147483647) {
                        searchInfo.quantity_1 = 2147483647;
                      }
                      if (v < 0) {
                        searchInfo.quantity_1 = 0;
                      }
                      handleSearchPackage();
                    }
                  "
                  placeholder="最低数量"
                  type="number"
                  clearable
                ></el-input>
                <span style="margin: 0 10px">至</span>
                <el-input
                  v-model="searchInfo.quantity_2"
                  @change="
                    (v) => {
                      if (v > 2147483647) {
                        searchInfo.quantity_2 = 2147483647;
                      }
                      if (v < 0) {
                        searchInfo.quantity_2 = 0;
                      }
                      handleSearchPackage();
                    }
                  "
                  placeholder="最高数量"
                  type="number"
                  clearable
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态:" prop="status">
              <el-radio-group
                v-model="searchInfo.status"
                @change="handleSearchPackage"
              >
                <el-radio-button :label="-1">不限</el-radio-button>
                <el-radio-button :label="1">上架</el-radio-button>
                <el-radio-button :label="2">下架</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="课包名称" prop="name"></el-table-column>
      <el-table-column label="课时数" prop="quantity"></el-table-column>
      <el-table-column label="1v1价格(元)" prop="price_1v1"></el-table-column>
      <el-table-column label="1vN价格(元)" prop="price_1vn"></el-table-column>
      <el-table-column label="状态" prop="status">
        <template slot-scope="scope">
          {{ scope.row.status === 1 ? "上架" : "下架" }}
        </template>
      </el-table-column>
      <el-table-column label="关联课程" prop="course_count">
        <template slot-scope="scope">
          {{
            scope.row.course_count === 0
              ? "全部"
              : scope.row.course_count + "个"
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="160" align="center">
        <template slot-scope="scope">
          <el-button class="mwow-button success" @click="toDetail(scope.row)"
            >编辑</el-button
          >
          <el-button
            class="mwow-button info"
            v-if="Number(scope.row.quantity) !== 1"
            @click="confirmDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { getCoursePackageListApi, deleteCoursePackageApi } from "@/api/course";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  props: ["visible"],
  components: { CommonSearchFormWrapper },
  data() {
    return {
      searchInfo: {
        name: "",
        quantity_1: "",
        quantity_2: "",
        status: -1,
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  created() {
    this.handleSearchPackage();
  },
  methods: {
    handleResetSearch() {
      this.searchInfo = {
        name: "",
        quantity_1: "",
        quantity_2: "",
        status: -1,
      };
      this.handleSearchPackage();
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.name) {
        option.name = this.searchInfo.name;
      }
      if (
        this.searchInfo.quantity_1 !== "" &&
        this.searchInfo.quantity_2 !== ""
      ) {
        if (
          Number(this.searchInfo.quantity_1) >
          Number(this.searchInfo.quantity_2)
        ) {
          this.$message({
            type: "warning",
            message: "课时数量范围有误",
          });
          return false;
        }
      }
      option.quantity_1 = this.searchInfo.quantity_1;
      option.quantity_2 = this.searchInfo.quantity_2;
      if (this.searchInfo.status >= 0) {
        option.status = this.searchInfo.status;
      }
      getCoursePackageListApi(option).then((res) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          this.page = params.page;
          this.total = res.data.total;
        }
      });
    },
    handleAddPackage() {
      this.$router.push({
        name: "storePackageDetail",
        query: {
          id: "0",
        },
      });
    },
    handleSearchPackage() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    toDetail(row) {
      this.$router.push({
        name: "storePackageDetail",
        query: {
          id: row.package_id,
        },
      });
    },
    confirmDelete(row) {
      this.$confirm(`确定删除课包？`, `删除 - ${row.name}`, {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        iconClass: "mwow-icon-error",
      })
        .then(() => {
          deleteCoursePackageApi({ package_id: row.package_id }).then((res) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.handleRefresh();
            } else {
              this.$message({
                type: "error",
                message: "删除失败!" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    },
    handleRefresh() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
